import React from "react";
import PropTypes from "prop-types";
import { Button, Result, notification } from "antd";

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null, errorInfo: null };
    this.handleReload = this.handleReload.bind(this);
  }

  static shouldIgnoreError(error) {
    const historyErrorPattern = /attempt to use history\.replacestate\(\) more than 100 times per 10 seconds/i;

    if (error && historyErrorPattern.test(error)) {
      return true;
    }

    return false;
  }

  static getDerivedStateFromError(error) {
    if (ErrorBoundary.shouldIgnoreError(error)) {
      return null;
    }
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    if (ErrorBoundary.shouldIgnoreError(error)) {
      return;
    }

    console.error("Unhandled error:", error, errorInfo);

    if (typeof window !== "undefined" && !this.state.errorInfo) {
      notification.error({
        message: "Unexpected Error",
        // description: "An unexpected error has occurred. Please try refreshing the page.",
        description: `Unhandled error: ${error}`,
        placement: "topRight",
      });
    }

    this.setState({ errorInfo });
  }

  handleReload() {
    window.location.reload();
  }

  // handleReset() {
  //   this.setState({ hasError: false, error: null, errorInfo: null });
  // }

  renderFallbackUI() {
    const { fallback, FallbackComponent } = this.props;

    if (FallbackComponent) {
      return <FallbackComponent error={this.state.error} />;
    }

    if (fallback) {
      return fallback;
    }

    return (
      <Result
        status="error"
        title="Oops! Something went wrong."
        subTitle="We encountered an unexpected error. Please try refreshing the page or contact support if the problem persists."
        extra={[
          <Button type="primary" onClick={this.handleReload} key="reload">
            Reload Page
          </Button>,
          // <Button onClick={this.handleReset} key="reset">
          //   Try Again
          // </Button>,
        ]}
      />
    );
  }

  render() {
    if (this.state.hasError) {
      return this.renderFallbackUI();
    }
    return this.props.children;
  }
}

ErrorBoundary.propTypes = {
  children: PropTypes.node.isRequired,
  fallback: PropTypes.element,
  FallbackComponent: PropTypes.elementType,
};

ErrorBoundary.defaultProps = {
  fallback: null,
  FallbackComponent: null,
};

export default ErrorBoundary;
